import React, { useState } from "react";
import FsLightbox from "fslightbox-react";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";
import gallery1 from "../../../assets/debate/debate_1.JPG";
import gallery2 from "../../../assets/debate/debate_2.JPG";
import gallery3 from "../../../assets/debate/debate_3.JPG";
import gallery4 from "../../../assets/debate/debate_4.JPG";
import gallery5 from "../../../assets/debate/debate_5.JPG";
import gallery6 from "../../../assets/debate/debate_6.JPG";
import gallery7 from "../../../assets/debate/debate_7.JPG";
import gallery8 from "../../../assets/debate/debate_8.JPG";
import gallery9 from "../../../assets/debate/debate_9.JPG";
import gallery10 from "../../../assets/debate/debate_10.JPG";
import gallery11 from "../../../assets/debate/debate_11.JPG";
import gallery12 from "../../../assets/debate/debate_12.JPG";
import gallery13 from "../../../assets/debate/debate_13.JPG";
import gallery14 from "../../../assets/debate/debate_14.JPG";
import gallery15 from "../../../assets/debate/debate_15.JPG";
import gallery16 from "../../../assets/debate/debate_16.JPG";
import gallery17 from "../../../assets/debate/debate_17.JPG";
import gallery18 from "../../../assets/debate/debate_18.JPG";
import gallery19 from "../../../assets/debate/debate_19.JPG";
import gallery20 from "../../../assets/debate/debate_20.JPG";
import gallery21 from "../../../assets/debate/debate_21.JPG";
import gallery22 from "../../../assets/debate/debate_22.JPG";
import gallery23 from "../../../assets/debate/debate_23.JPG";
import gallery24 from "../../../assets/debate/debate_24.JPG";
import gallery25 from "../../../assets/debate/debate_25.JPG";
import gallery26 from "../../../assets/debate/debate_26.JPG";
import gallery27 from "../../../assets/debate/debate_27.JPG";
import gallery28 from "../../../assets/debate/debate_28.JPG";
import gallery29 from "../../../assets/debate/debate_29.JPG";
import gallery30 from "../../../assets/debate/debate_30.JPG";
import gallery31 from "../../../assets/debate/debate_31.JPG";
import gallery32 from "../../../assets/debate/debate_32.JPG";

const Gallery = () => {
  const theme = useTheme();

  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const isMd = useMediaQuery(theme.breakpoints.up("md"), {
    defaultMatches: true,
  });

  const photos = [
    gallery1,
    gallery2,
    gallery3,
    gallery4,
    gallery5,
    gallery6,
    gallery7,
    gallery8,
    gallery9,
    gallery10,
    gallery11,
    gallery12,
    gallery13,
    gallery14,
    gallery15,
    gallery16,
    gallery17,
    gallery18,
    gallery19,
    gallery20,
    gallery21,
    gallery22,
    gallery23,
    gallery24,
    gallery25,
    gallery26,
    gallery27,
    gallery28,
    gallery29,
    gallery30,
    gallery31,
    gallery32,
  ];

  const photosToShow = isMd ? photos : photos.slice(0, photos.length);

  return (
    <Box>
      <Box marginTop={{ xs: "25%", sm: "5%" }}>
        {photosToShow.map((item, index) => (
          <Box
            component="img"
            height={{ xs: "27vh", sm: "26vh" }}
            onClick={() => {
              setCurrentImageIndex(index);
              setIsViewerOpen(!isViewerOpen);
            }}
            sx={{
              cursor: "pointer",
              objectFit: "cover",
            }}
            src={item}
            alt={"oof_img"}
            marginRight={{ xs: "0%", sm: "0.5%" }}
            marginBottom={{ xs: "1%", sm: "0.5%" }}
            width={{ xs: "100%", sm: "24%" }}
          />
        ))}

        <FsLightbox
          toggler={isViewerOpen}
          sources={photos}
          slide={currentImageIndex + 1}
        />
      </Box>
    </Box>
  );
};

export default Gallery;
